import { useRoleBadges } from "@/modules/mobileHome/useSectionBadges";
import { CustomLink } from "@/styles/shared/link/link.style";
import { Container, Group, Stack, Text, UnstyledButton } from "@mantine/core";
import { IconCalendar, IconHome, IconLayoutGrid, IconMoodSmile, IconPlus } from "@tabler/icons-react";
import { Footer } from "./style";
import CreateSheet from "./CreateSheet";
import { useDisclosure } from "@mantine/hooks";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LayoutFooter = () => {
  const [opened, { open, close }] = useDisclosure(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const today = useMemo(() => new Intl.DateTimeFormat("fa-IR", { day: "numeric" }).format(new Date()), []);
  const badges = useRoleBadges();
  // New online bookings or reviews waiting to be checked, visible from every page.
  const menuNeedsAttention = (badges.onlineBookings ?? 0) + (badges.pendingReviews ?? 0) > 0;

  // Replacing the sheet's history entry keeps the back button from reopening the sheet.
  const goTo = (to: string) => {
    close();
    navigate(to, { replace: true });
  };

  return (
    <Stack
      styles={{
        root: {
          position: "relative",
          zIndex: 100
        },
      }}
    >
      <Footer>
        <Container size="xs">
          <nav aria-label="ناوبری اصلی">
            <Group gap={2} justify="space-between" px="xs" mih={62} grow>
              <CustomLink to="/dashboard" aria-current={pathname === "/dashboard" ? "page" : undefined}>
                <Stack className="footer-nav-item" data-active={pathname === "/dashboard" || undefined} align="center" gap={2} py={5}>
                  <IconHome size={23} strokeWidth={1.6} aria-hidden />
                  <Text className="footer-label">خانه</Text>
                </Stack>
              </CustomLink>
              <CustomLink to="/dashboard/customers">
                <Stack className="footer-nav-item" data-active={pathname.startsWith("/dashboard/customers") || undefined} align="center" gap={2} py={5}>
                  <IconMoodSmile size={23} strokeWidth={1.6} aria-hidden />
                  <Text className="footer-label">مشتریان</Text>
                </Stack>
              </CustomLink>
              <UnstyledButton
                id="add-customer"
                className="footer-create"
                aria-label="ثبت: نوبت، فاکتور، مشتری یا پیامک"
                aria-haspopup="dialog"
                onClick={open}
              >
                <span className="footer-create-icon">
                  <IconPlus size={22} strokeWidth={2} aria-hidden />
                </span>
                <Text className="footer-label">ثبت</Text>
              </UnstyledButton>
              <CustomLink to="/dashboard/calendar">
                <Stack className="footer-nav-item" data-active={pathname.startsWith("/dashboard/calendar") || undefined} align="center" gap={2} py={5}>
                  <span className="calendar-icon" aria-hidden>
                    <IconCalendar size={23} strokeWidth={1.6} />
                    <span className="calendar-day">{today}</span>
                  </span>
                  <Text className="footer-label">تقویم</Text>
                </Stack>
              </CustomLink>
              <CustomLink to="/dashboard/menu" aria-label={menuNeedsAttention ? "منو، موارد تازه برای بررسی" : undefined}>
                <Stack className="footer-nav-item" data-active={pathname.startsWith("/dashboard/menu") || undefined} align="center" gap={2} py={5}>
                  <span className="nav-icon" aria-hidden>
                    <IconLayoutGrid size={23} strokeWidth={1.6} />
                    {menuNeedsAttention && <span className="nav-dot" />}
                  </span>
                  <Text className="footer-label">منو</Text>
                </Stack>
              </CustomLink>
            </Group>
          </nav>
        </Container>
      </Footer>
      <CreateSheet opened={opened} close={close} goTo={goTo} />
    </Stack>
  );
};

export default LayoutFooter;
